import PropTypes from 'prop-types'
import { ForbiddenPage } from 'components/elements'
import List from 'containers/pages/adminManagement/role/List'
import Detail from 'containers/pages/adminManagement/role/Detail'
import Form from 'containers/pages/adminManagement/role/Form'

const Role = ({ location, match, currentUser }) => {
  if (location.pathname === '/admin-management/role') {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-user-role-managementuser-role-access-matrix-read') > -1) {
      return <List location={location} />
    }
    return <ForbiddenPage />
  }

  if (match.params.id && location.pathname.includes('/detail')) {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-user-role-managementuser-role-access-matrix-read') > -1) {
      return <Detail match={match} location={location} />
    }
    return <ForbiddenPage />
  }

  if (location.pathname.includes('/edit') || location.pathname.includes('/add')) {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-user-role-managementuser-role-access-matrix-write') > -1) {
      return <Form match={match} location={location} />
    }
    return <ForbiddenPage />
  }
  return ''
}

Role.propTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
}

export default Role
